import { createRouteRef, createSubRouteRef } from '@mainstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-prototype',
});

export const editPrototypeRouteRef = createSubRouteRef({
  id: 'catalog-release',
  parent: rootRouteRef,
  path: '/edit',
});
